module.exports = __webpack_public_path__ + "images/d4312e48971182ef6afd4789f91defee-illu_dir_motion1.svg";